import { handleActions } from "redux-actions";

import { setOneStep, mergeOneStep } from "./actions";

const initialState = {
    isOpenBackdrop: false,
    isLoader: false
};

export const stepOneReducer = handleActions(
    {
        [setOneStep]: (state, { payload }) => ({
            ...initialState,
            ...payload
        }),
        [mergeOneStep]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);
